import { RawTeamMember, TeamMemberDto } from '../model/TeamMember';

export const parseTeamMember = (data: TeamMemberDto): RawTeamMember => ({
  photo: data.key + '.webp',
  name: {
    cs: data.name,
    en: translateNameToEng(data.name),
  },
  positions: {
    cs: [data.title_cs],
    en: [data.title_en],
  },
});

const translateNameToEng = (value: string): string => {
  value = value.replace('Bc. ', '');
  value = value.replace('Ing. ', '');
  value = value.replace('Mgr. ', '');
  value = value.replace('BcA. ', '');
  value = value.replace(', Dis.', '');
  if (value.includes('MUDr.')) {
    value = value.replace('MUDr. ', '');
    value = `${value}, M.D.`;
  }
  return value;
};
